import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { SvgAvatarPipe } from './utilities';

export enum AvatarMode {
    Letter = 'letter',
    Image = 'image',
    Icon = 'icon',
    Text = 'text',
    Template = 'template'
}


@Component({
    selector: 'w-avatar',
    templateUrl: 'avatar.component.html',
    styleUrls: ['avatar.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        SvgAvatarPipe,
    ],
})
export class AvatarComponent {

    @Input() value: string;
    @Input() mode: AvatarMode = AvatarMode.Letter;
    @Input() size: number = 30;
    @Input() border: boolean = false;

    // @Input() badge: string | TemplateRef<any>;
    // @Input() statusIcon: string;

    @Output() onImageError = new EventEmitter<Event>();

    readonly AvatarMode = AvatarMode;

    imageError(event: Event) {
        this.onImageError.emit(event);
    }

    containerClass() {
        return {
            'w-avatar-container': true,
            // 'has-status-icon': !!this.statusIcon
        }
    }

    containerStyle() {
        const size = this.size;
        return {
            'width': `${size}px`,
            'height': `${size}px`,
            'line-height': `${size}px`
        }
    }

}
